import { TFunction } from "i18next";
import { BreadcrumbsRoute } from "use-react-router-breadcrumbs";

export const breadcrumbsFactory = (t: TFunction): BreadcrumbsRoute[] => {
    return [
        { path: "/", breadcrumb: t("routes.main") },
        // { path: "/user", breadcrumb: null },
        { path: "/login", breadcrumb: t("routes.login") },
        { path: "/registration", breadcrumb: t("routes.registration") },
        { path: "/profile", breadcrumb: t("routes.profile") },
        { path: "/create-work", breadcrumb: t("routes.createWork") },
        { path: "/catalog", breadcrumb: t("routes.catalog") },
        { path: "/subscription", breadcrumb: t("routes.subscription") },
        { path: "/notifications", breadcrumb: t("routes.notifications") },
        { path: "/contacts", breadcrumb: t("routes.contacts") },
        { path: "/documents", breadcrumb: t("routes.documents") },
        { path: "/applications", breadcrumb: t("routes.applications") },
        { path: "/created-orders", breadcrumb: t("routes.createdOrders") },
        { path: "/completed-orders", breadcrumb: t("routes.completedOrders") },
        { path: "/saved", breadcrumb: t("routes.saved") },
    ];
};
